import _extends from "@babel/runtime/helpers/extends";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
const withInfiniteScroll = Component => {
  const InfiniteComponent = props => {
    const {
      initialOffset,
      orderedListData,
      actionKey,
      limitToUse,
      fetchMore,
      listTotal
    } = props;
    const [isFetching, setIsFetching] = useState(false);
    const [newData, setNewData] = useState(null);
    const updateQuery = (prevQuery, {
      fetchMoreResult
    }) => {
      if (!fetchMoreResult || !fetchMoreResult[actionKey]) return prevQuery;
      const {
        results: moreResults
      } = fetchMoreResult[actionKey];
      const updatedResults = [...prevQuery[actionKey].results, ...moreResults];
      setIsFetching(false);
      setNewData(moreResults);
      return {
        [actionKey]: {
          results: updatedResults,
          total: fetchMoreResult[actionKey].total
        }
      };
    };
    const triggerInfiniteScroll = async () => {
      const dataLength = orderedListData.length;
      const newOffset = dataLength + initialOffset;
      if (isFetching || limitToUse && dataLength >= limitToUse || dataLength >= listTotal) return;
      setIsFetching(true);
      await fetchMore({
        variables: {
          offset: newOffset
        },
        updateQuery
      });
    };
    return /*#__PURE__*/React.createElement(Component, _extends({
      triggerInfiniteScroll: triggerInfiniteScroll,
      gtmData: newData
    }, props));
  };
  InfiniteComponent.propTypes = {
    initialOffset: PropTypes.number.isRequired,
    orderedListData: PropTypes.array.isRequired,
    actionKey: PropTypes.string.isRequired,
    limitToUse: PropTypes.number.isRequired,
    fetchMore: PropTypes.func.isRequired,
    itemsPerPageToUse: PropTypes.number.isRequired,
    listTotal: PropTypes.number.isRequired
  };
  return InfiniteComponent;
};
export default withInfiniteScroll;
//# sourceMappingURL=withInfiniteScroll.js.map